module.exports = __webpack_public_path__ + "img/document.94f521e1.svg";